import React from 'react';
import GoogleLoginPage from '../../components/GoogleLoginPage';

export default function AdminLogin() {
  return (
    <GoogleLoginPage
      intent="admin"
      title="Administration"
      subtitle="Atelier Météris - Boutique"
      description="Connectez-vous avec votre compte Google autorise pour gerer la boutique, les reservations et les utilisateurs."
      helperText="Acces reserve aux gestionnaires et administrateurs autorises."
    />
  );
}
